import React from 'react';
import { useStyletron } from 'baseui';
import { KIND, SIZE, Tag } from 'baseui/tag';
import { LabelSmall } from 'baseui/typography';
import { useAtomValue, useSetAtom } from 'jotai';
import { RESET } from 'jotai/utils';
import { drawerAtom, reviewAnnotationsAtom } from '../atoms';
import { ObjectDetailsPanel } from '../completed-panel/object-details-panel';
import { REVIEW_ANNOTATION_STATUS } from '../constants';
import { FeedbackPanel } from '../feedback-panel';
import type { CompletedAnnotationT } from '../types';
export const useReviewDrawer = () => {
  const [_, theme] = useStyletron();
  const setDrawer = useSetAtom(drawerAtom);
  const annotations = useAtomValue(reviewAnnotationsAtom);
  const openObjectDetailsPanel = ({
    annotationId,
    status
  }: CompletedAnnotationT, handleRevertToPending: () => void) => {
    const annotation = annotations[annotationId];
    // @ts-expect-error todo(ts-migration) TS18048 'annotation' is possibly 'undefined'.
    const title = annotation.name;
    const onClickRevertToPending = () => {
      handleRevertToPending();
      setDrawer(RESET);
    };
    setDrawer({
      isOpen: true,
      title,
      descriptionComponent: () => <div>
          <Tag kind={status === REVIEW_ANNOTATION_STATUS.APPROVED ? KIND.positive : KIND.negative} size={SIZE.small} closeable={false} overrides={{
          Root: {
            style: {
              margin: 0
            }
          }
        }}>
            {status === REVIEW_ANNOTATION_STATUS.APPROVED ? 'Approved' : 'Rejected'}
          </Tag>
        </div>,
      component: () => <ObjectDetailsPanel
      // @ts-expect-error todo(ts-migration) TS2322 Type 'ReviewAnnotationT | undefined' is not assignable to type 'ReviewAnnotationT'.
      annotation={annotation} handleRevertToPending={onClickRevertToPending} />
    });
  };
  const openFeedbackPanel = () => {
    setDrawer({
      isOpen: true,
      title: 'Feedback',
      descriptionComponent: () => <LabelSmall color={theme.colors.contentTertiary}>Add or remove feedback</LabelSmall>,
      component: () => <FeedbackPanel />
    });
  };
  return {
    openFeedbackPanel,
    openObjectDetailsPanel
  };
};